import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'
import BackEndAPI from '../../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import { MensagemTipo } from '../../../GlobalStates/MensagemState'
import Condicional from '../../../Layout/Condicional'
import SearchText from '../../../DevComponents/SearchText'
import SelectMultiplo from '../../../DevComponents/SelectMultiplo'
import InputText from '../../../DevComponents/InputText'
import { UsuarioInterface } from '../../../ImportBackend/Interfaces/UsuarioInterfaces'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'

interface EmpresaInterface {
  id: number
  descricao: string
}

export default function UsuariosEmpresas () {

  const navigate = useNavigate()

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const clsApi = new BackEndAPI()

  const [usuarioSelecionado, setUsuarioSelecionado] = useState<UsuarioInterface | null>( null )

  const [dadosEmpresas, setDadosEmpresas] = useState<{ empresas: Array<EmpresaInterface> }>( { empresas: [] } )

  const btFechar = () => {
    navigate( '/' )
  }

  const exibirErro = ( mensagem: string ) => {
    setMensagemState( {
      ...mensagemState,
      exibir: true,
      mensagem: mensagem,
      tipo: MensagemTipo.Error,
      exibirBotao: true
    } )
  }

  const onSelecionarUsuario = ( usuario: UsuarioInterface | null ) => {

    setUsuarioSelecionado( usuario )
    setDadosEmpresas( { empresas: [] } )

    if ( usuario ) {

      const query = `
        getUsuarioEmpresas(idUsuario: ${usuario.idUsuario})
      `

      clsApi.query<Array<{ idEmpresa: number }>>( query, 'getUsuarioEmpresas', 'Consultando Empresas do Usuário...', contexto ).then( rs => {

        setDadosEmpresas( { empresas: rs.map( v => ( { id: v.idEmpresa, descricao: '' } ) ) } )

      } ).catch( () => {
        exibirErro( 'Erro ao Consultar Empresas do Usuário!' )
      } )

    }

  }

  const onAlterarNaoRestringirEmpresa = ( naoRestringirEmpresa: boolean ) => {

    if ( !usuarioSelecionado ) return

    const mutation = `
      alterarNaoRestringirEmpresa(idUsuario: ${usuarioSelecionado.idUsuario}, naoRestringirEmpresa: ${naoRestringirEmpresa}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'alterarNaoRestringirEmpresa', 'Alterando...', contexto ).then( rs => {

      if ( rs.ok ) {
        setUsuarioSelecionado( { ...usuarioSelecionado, naoRestringirEmpresa: naoRestringirEmpresa } )
      } else {
        exibirErro( rs.mensagem )
      }

    } ).catch( () => {
      exibirErro( 'Erro ao Alterar Restrição de Empresas!' )
    } )

  }

  // Grava a cada seleção/remoção de empresa (mesmo critério do checkbox naoRestringirEmpresa) -
  // manda sempre a lista completa, salvarEmpresasUsuario substitui todo o vínculo do usuário.
  const onAlterarEmpresas = ( empresas: Array<EmpresaInterface> ) => {

    if ( !usuarioSelecionado ) return

    const empresasAnteriores = dadosEmpresas.empresas

    setDadosEmpresas( { empresas: empresas } )

    const idsEmpresas: string = JSON.stringify( empresas.map( e => e.id ) )

    const mutation = `
      salvarEmpresasUsuario(idUsuario: ${usuarioSelecionado.idUsuario}, idsEmpresas: ${idsEmpresas}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'salvarEmpresasUsuario', 'Gravando Empresas...', contexto ).then( rs => {

      if ( !rs.ok ) {
        setDadosEmpresas( { empresas: empresasAnteriores } )
        exibirErro( rs.mensagem )
      }

    } ).catch( () => {
      setDadosEmpresas( { empresas: empresasAnteriores } )
      exibirErro( 'Erro ao Gravar Empresas do Usuário!' )
    } )

  }

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Empresas por Usuário
              </Typography>

              <IconButton onClick={() => btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} sx={{ mb: 3 }}>

              <SearchText
                onChange={onSelecionarUsuario}
                objQuery='{idUsuario, nome, naoRestringirEmpresa}'
                campoPesquisa='nome'
                campoID='idUsuario'
                label='Buscar Usuário'
                value={usuarioSelecionado}
                mensagemQuery='Procurando Usuários...'
                campoQuery='pesquisa'
                nomeQuery='getUsuarios'
              />

            </Grid>

            <Condicional condicao={usuarioSelecionado !== null}>

              <Grid item xs={12} sx={{ mb: 3 }}>

                <InputText
                  dados={usuarioSelecionado || {}}
                  field='naoRestringirEmpresa'
                  label='Permtir Todas as empresas'
                  tipo='checkbox'
                  onChange={onAlterarNaoRestringirEmpresa}
                />

              </Grid>

              <Condicional condicao={usuarioSelecionado !== null && !usuarioSelecionado?.naoRestringirEmpresa}>

                <Grid item xs={12} sx={{ mb: 3 }}>

                  <SelectMultiplo
                    label='Empresas Permitidas'
                    dados={dadosEmpresas}
                    onChange={onAlterarEmpresas}
                    field='empresas'
                    fieldIdSelect='id'
                    fieldSelect='descricao'
                    fieldsRetornoObjeto={['id', 'descricao']}
                    pesquisaInicial={{
                      pesquisa: 'getEmpresas',
                      tipo: 'Query',
                      objRetorno: 'getEmpresas',
                      mensagem: 'Consultando Empresas...'
                    }}
                  />

                </Grid>

              </Condicional>

            </Condicional>

          </Grid>
        </Paper>

      </Container>
    </>
  )

}
